<template>
  <div class="empty-layout">
    <Navbar/>
    <main id="content">
      <!---carousel--->
      <Widget position="slider"/>
      <router-view></router-view>
    </main>
    <Footer/>
  </div>
</template>

<script>
  import Navbar from '@/components/Navbar'
  import Footer from '@/components/Footer'
  import Widget from '@/components/app/Widget'

  export default {
    name: 'empty-layout',
    components: {
      Navbar,
      Footer,
      Widget
    },
  }
</script>
